/**
 * Design tokens for the Audit Log Explorer, mirrored 1:1 from the Claude Design
 * handoff (`Audit Log Explorer.html` :root block). Kept local to this feature so
 * the bespoke filter bar / table / drawer match the mock pixel-for-pixel without
 * leaking feature-specific shades into the global theme.
 */
export const ALE = {
    // primary
    pMain: '#11A7E2',
    pDark: '#206FA5',
    pDarker: '#142F53',
    pLight: '#78D1F1',
    // greys
    g0: '#FFFFFF',
    g100: '#F9FAFB',
    g200: '#F4F6F8',
    g300: '#DFE3E8',
    g400: '#C4CDD5',
    g500: '#919EAB',
    g600: '#637381',
    g700: '#454F5B',
    g800: '#212B36',
    g900: '#161C24',
    // surfaces
    pageBg: '#F5F7FA',
    cardBg: '#FFFFFF',
    border: '#E2E7ED',
    rowHover: '#F8FAFC',
    headerStrip: '#FAFBFC',
    // text
    tPrimary: '#1a1a2e',
    tSecondary: '#4A5568',
    tMuted: '#6B7A90',
    tFaint: '#9AA4B5',
    // status ghost badges
    successT: '#25b660',
    successBg: '#E9FCD4',
    infoT: '#01579B',
    infoBg: '#D0F2FF',
    warnT: '#B78103',
    warnBg: '#FFF7CD',
    errorT: '#FF4842',
    errorBg: '#FFE7D9',
    neutralT: '#64748B',
    neutralBg: '#F1F5F9',
    // misc
    shadowCard: '0 1px 2px rgba(33,43,54,.04), 0 4px 16px rgba(33,43,54,.06)',
    shadowDrawer: '-12px 0 40px rgba(33,43,54,.16)',
    mono: "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
} as const;

/** Status-class → ghost badge color set. */
export const statusBadgeColors = (code: number) => {
    if (code >= 500) return { bg: ALE.errorBg, fg: ALE.errorT };
    if (code >= 400) return { bg: ALE.warnBg, fg: ALE.warnT };
    if (code >= 300) return { bg: ALE.infoBg, fg: ALE.infoT };
    return { bg: ALE.successBg, fg: ALE.successT };
};
